import { decodeBinaryBodyForDisplay } from '../electron-shared/utils/binary-body';
import {
  formatHttpRequest as formatHttpRequestShared,
  formatHttpResponse as formatHttpResponseShared,
  isValidHttpStatusCode,
  type HttpRequestModel,
  type HttpResponseModel,
} from '@terra/shared-utils';

export function formatHttpRequestRaw(request: HttpRequestModel): string {
  const displayBody = request.body
    ? decodeBinaryBodyForDisplay(request.body)
    : request.body;

  return formatHttpRequestShared({
    ...request,
    body: displayBody,
  });
}

export function formatHttpResponseRaw(response: {
  status: number;
  statusMessage: string;
  headers: HttpResponseModel['headers'];
  rawHeaders?: string[];
  body?: string;
  httpVersion: string;
}): string {
  if (!isValidHttpStatusCode(response.status)) {
    return '';
  }

  const displayBody = response.body
    ? decodeBinaryBodyForDisplay(response.body)
    : response.body;

  return formatHttpResponseShared({
    statusCode: response.status,
    statusMessage: response.statusMessage,
    headers: response.headers,
    rawHeaders: response.rawHeaders,
    body: displayBody,
    httpVersion: response.httpVersion,
  });
}
